/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Common_Terms_Of_ServiceInputs */

const en_auth_common_terms_of_service = /** @type {(inputs: Auth_Common_Terms_Of_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms of Service`)
};

const es_auth_common_terms_of_service = /** @type {(inputs: Auth_Common_Terms_Of_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminos del servicio`)
};

/**
* | output |
* | --- |
* | "Terms of Service" |
*
* @param {Auth_Common_Terms_Of_ServiceInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_common_terms_of_service = /** @type {((inputs?: Auth_Common_Terms_Of_ServiceInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Common_Terms_Of_ServiceInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_common_terms_of_service(inputs)
	return es_auth_common_terms_of_service(inputs)
});